<template>
  <div>
        <Mainlayout></Mainlayout>
    <CCard class="h-100">
      <CCol sm="12" class="justify-content-center mt-5 m-0">
        <CContainer>
          <CCol sm="12" lg="12" class="custom-margin mt-5">
            <!-- kad besaq -->
            <br />
            <br />
            <br />
            <br />
            
            <CCard body-wrapper text-color="black" class="custom-bg-primary">
              <CRow>
                <CCol sm="12"
                  ><div style="text-align: right">
                    Additional Mathematic
                  </div></CCol
                >
              </CRow>
              <br />
              <h3>Daily Quiz Feb 17th - Additional Mathematic</h3>
              <br />
              <CRow>
                <div class="col-4">
                  <img
                    src="../assets/img/icondefaultimage.png"
                    width="80px"
                  />
                </div>
                <div class="col-8">
                  <p>Today we will do some exercise type roots of quadratics equations </p>
                </div>
              </CRow>
              <br /><br />
              <!-- kad kecik -->
              <CCard
                body-wrapper
                class="bottom-center m-0 custom-bg-info"
              >
                <div class="bottom-icon-left"><CIcon name="cil-heart"/></div>
                <div class="bottom-view-right"><a  @click="GotoQuiz()"> <strong>Crack it! > </strong> </a></div>
              </CCard>
            </CCard>

            <CRow>
              <div
                class="mx-auto d-flex justify-content-center col-12 ml-4 mt-1"
              >
                <div class="text-center custom-width-lg"></div>
              </div>
            </CRow>
          </CCol>
        </CContainer>
      </CCol>
    </CCard>
    <div
      style="
        background-size: cover;
        color: #fff;
        position: fixed;
        width: 100%;
        top: 0px;
      "
      :style="{ backgroundImage: `url(${backgroundBanner})` }"
      class="d-none d-sm-flex"
    >
      <div style="width: 100%" class="mt-5 m-0">
        <h3 class="text-center text-white m-0">Create Quiz</h3>
        <br /><br />
      </div>
    </div>
   
  </div>
</template>


<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import Mainlayout from "../containers/TheHeaderWebStudent.vue";
import moment from "moment";
import backgroundBanner from "../assets/img/bgApps.jpg";
import _ from "lodash";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-timepicker", VueTimepicker);
Vue.component("v-select", vSelect);
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
// Tell Vue to install the plugin.
Vue.use(VuejsDialog);
export default {
  name: "Login",
  components: {
    PulseLoader,
     Mainlayout,
  },
  data() {
    return {
      backgroundBanner,
      subjects: [],
      grades: [],
      SelectedSubject: "",
      SelectedGrade: "",
      Question: "",
      SelectedTimer: "",
      SubmittedForm: false,
      Error: false,
      question: "",
    };
  },
  async mounted() {
    this.SessionUserIdNo();
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
    this.GetSubject();
    this.GetGrade();
      } else {
      this.GoToLogin();
    }
  },
  computed: {
    isDisabled: function () {
      return !this.SelectedSubject.Id || !this.SelectedGrade.Id;
    },
  },
  methods: {
    async GetSubject() {
      this.$API
        .get(this.$QuizSubjectList, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.subjects = response.data;
          }
        });
    },
    async GetGrade() {
      this.$API
        .get(this.$QuizGradeList, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.grades = response.data;
          }
        });
    },
    CreateQuizTitle() {
      this.SubmittedForm = true;
      if (
        this.SelectedSubject.Id === "" &&
        this.SelectedGrade.Id === "" &&
        this.Question === ""
      ) {
        this.Error = true;
      } else {
        this.Error = false;
        const formData = new FormData();

        formData.append("userId", this.$route.query.userID);
        formData.append("title", this.Question);
        formData.append("subjectId", this.SelectedSubject.Id);
        formData.append("gradeId", this.SelectedGrade.Id);
        formData.append("Timer", this.SelectedTimer);

        return this.$API
          .post(this.$CreateQuizTitle, formData, {
            withCredentials: true,
          })
          .then((response) => {
            console.log(response.data);
            console.log(response.status);
            if (response.status == 200 && response.data != null) {
            }
          })
          .catch((error) => {
            if (error.response) {
              this.Busy = false;
              this.Error = true;
              console.log(error.response.status);
            }
          });
      }
    },

     GotoQuiz()
    {
      this.$router.push("/QuizStudentQuestion");
    }
  },
};
</script>
